export default __webpack_public_path__ + "static/media/update_support.4c0a0b4a.svg";